import { GetManifestsRequest, ListManifestsRequest } from '../../protobuf/service_query_pb';

export const DEFAULT_PAGE_SIZE = 15;

export function ManifestGetRequest(id) {
  const request = new GetManifestsRequest();
  request.setManifestIdsList([id])
  return request;
}

export function ManifestListRequest() {
  const request = new ListManifestsRequest();
  return request;
}
